module.exports = __webpack_public_path__ + "static/media/CharlesThomas04.bb29024e.jpg";